import { ReactElement } from "react";

import { FunnelSimple } from "@magnetic/icons";

import { Button } from "src/components/buttons";
import { HFlex } from "src/components/hFlex";

import "./clientFilters.scss";

export interface ClientFilterBarProps {
  readonly onReset: () => void | undefined;
  readonly onFilterClick: () => void | undefined;
  readonly showResetButton: boolean | undefined;
  readonly children: ReactElement;
}
export const ClientFilterBar = ({
  children,
  onFilterClick,
  showResetButton,
  onReset
}: ClientFilterBarProps) => {
  return (
    <HFlex>
      <div className="fiter-container">
        <HFlex>
          {children}
          {showResetButton && (
            <Button name="reset-all" kind="tertiary" onClick={onReset}>
              Reset all
            </Button>
          )}
        </HFlex>
      </div>
      <Button
        name="open-filters"
        icon={<FunnelSimple className="filter-icon" />}
        kind="tertiary"
        onClick={onFilterClick}
        className="filter-drawer-button"
      >
        Filters
      </Button>
    </HFlex>
  );
};
